import {
  ENTITY_SUGGESTIONS_MAX_HEIGHT,
  ENTITY_SUGGESTIONS_MAX_WIDTH,
  ENTITY_SUGGESTIONS_MIN_WIDTH,
} from './TeamChatEntitySuggestions.constants';

export const rootStyles = {
  position: 'absolute',
  bottom: '100%',
  left: 0,
  marginBottom: 1,
  minWidth: ENTITY_SUGGESTIONS_MIN_WIDTH,
  maxWidth: ENTITY_SUGGESTIONS_MAX_WIDTH,
  boxShadow: 4,
  backgroundColor: 'background.paper',
  borderRadius: 2,
  border: '1px solid',
  borderColor: 'divider',
  zIndex: 10,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

export const titleStyles = {
  display: 'block',
  padding: '8px 14px 4px',
  borderBottom: '1px solid',
  borderColor: 'divider',
};

export const listStyles = {
  maxHeight: ENTITY_SUGGESTIONS_MAX_HEIGHT,
  overflowY: 'auto',
  padding: 0.5,
};

export const groupHeaderStyles = {
  display: 'block',
  padding: '6px 10px 2px 14px',
  color: 'text.secondary',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
};

export const itemStyles = {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  padding: '6px 10px 6px 14px',
  borderRadius: 1,
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'action.hover',
  },
};

export const focusedItemStyles = {
  ...itemStyles,
  backgroundColor: 'action.selected',
  '&::before': {
    content: '""',
    position: 'absolute',
    left: 4,
    top: 6,
    bottom: 6,
    width: 2,
    borderRadius: 1,
    backgroundColor: 'primary.main',
  },
};

export const textColumnStyles = {
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
};

export const primaryTextStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const secondaryTextStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const emptyStateStyles = {
  padding: '12px 14px',
  color: 'text.secondary',
};

export const loadingRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  padding: '12px 14px',
  color: 'text.secondary',
};

export const footerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  padding: '6px 12px',
  borderTop: '1px solid',
  borderColor: 'divider',
  backgroundColor: 'background.default',
};

export const hintStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  color: 'text.secondary',
};

export const hintKeyStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 18,
  height: 18,
  padding: '0 4px',
  borderRadius: 0.5,
  border: '1px solid',
  borderColor: 'divider',
  backgroundColor: 'background.paper',
  color: 'text.secondary',
  // Intentionally below the smallest CDS scale step: keyboard-key glyphs inside an 18px kbd
  // chrome — 12px text overflows the bordered key cap.
  fontSize: 11,
  lineHeight: 1,
};
